function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M83 22l22-22v42H83zM213 22L191 0v42h22z",
  fill: "#7b7b7b",
  fillRule: "evenodd"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M105 0h86v21h-86z",
  fill: "#5a5a5a"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M272 264H24a24 24 0 0 1-24-24V83.238L41.238 42h213.524L296 83.238V240a24 24 0 0 1-24 24z",
  fill: "#e6e7e8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 127V83.238L41.238 42h213.524L296 83.238V127z",
  fill: "#d0d1d2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34 264V94a10 10 0 0 1 10-10h208a10 10 0 0 1 10 10v170z",
  fill: "#458cf5"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M34 127h228v137H34z",
  fill: "#fff"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M194 264v-41l-20-20-13-36 9-23 51 51 9-38 32 32v75z",
  fill: "#d2d3d4",
  fillRule: "evenodd"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M49 143h76v85H49zM49 247h98v17H49z",
  fill: "#d2d3d4"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M213 232.1V264h-42v-31.447a49.507 49.507 0 0 1-1-89.651V190l21 13 22-13v-47.1a49.518 49.518 0 0 1 0 89.2z",
  fill: "#505050",
  fillRule: "evenodd"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M57.5 95a8.5 8.5 0 1 1-8.5 8.5 8.5 8.5 0 0 1 8.5-8.5zm25 0a8.5 8.5 0 1 1-8.5 8.5 8.5 8.5 0 0 1 8.5-8.5z",
  fill: "#e6e7e8",
  fillRule: "evenodd"
});

const SvgGoogleSearchConsole = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  height: 2230,
  width: 2500,
  viewBox: "0 0 296 264",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGoogleSearchConsole, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/google_search_console.8851ff1d.svg";
export { ForwardRef as ReactComponent };